import { accountExportTemplateEntityName } from '../../../../../backend/features/accounts/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { useEntityDataTable } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, Grid } from '@mui/material';
import React from 'react';
import { AccountExportTemplateList } from './AccountExportTemplateList';
export const AccountExportTemplateTable = ({ onEditTemplate, onAfterEditTemplate, onTemplateChange, }) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'search',
            label: t('common.search'),
        });
    }, [t]);
    const mapEntityFilterData = (filterData) => {
        const filter = [
            {
                column: 'accountId',
                op: '=',
                value: userState.id,
            },
        ];
        if (filterData.search) {
            filter.push({
                column: 'search',
                op: 'full-text-query',
                value: filterData.search,
            });
        }
        return filter;
    };
    const { dataTableProps, reload } = useEntityDataTable({
        entityName: accountExportTemplateEntityName,
        title: '',
        columns: [],
        defaultSortColumnKey: 'name',
        filterConfig,
        mapEntityFilterData,
    }, { rowSelectionEnabled: true });
    const handleAfterEditTemplate = () => {
        reload();
        onAfterEditTemplate();
    };
    return (React.createElement(DataTable, Object.assign({}, dataTableProps, { title: undefined, customTableContentComponent: Empty, customTablePaginationContentComponent: Empty, customTableSurfaceComponent: CustomTableSurfaceComponent, customHeaderElement: null, customFilterBarSurfaceComponent: CustomFilterBarSurfaceComponent, customContentElement: React.createElement(AccountExportTemplateList, { dataTableProps: dataTableProps, onAfterDeleteTemplate: reload, onAfterEditTemplate: handleAfterEditTemplate, onEditTemplate: onEditTemplate, onTemplateChange: onTemplateChange }) })));
};
const Empty = () => null;
const CustomTableSurfaceComponent = ({ children }) => {
    return React.createElement(Box, null, children);
};
const CustomFilterBarSurfaceComponent = ({ children }) => {
    return (React.createElement(Box, { ml: 6.25, pb: 2, pt: 1 },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, md: 3 }, children))));
};
